module.exports = __webpack_public_path__ + "static/media/cda1024s.82c95bc9.png";